// @ts-nocheck
import React from "react";
import { locations } from "src/constants/account";
import { Field } from "src/components/Forms/Field";
import { FormikProps } from "formik";
import { RemoveIcon } from "../../../Wrapper";
import { FormikSelect } from "src/components/Forms/Select";

interface Props {
  formProps: FormikProps<any>;
  clearFilterKey: (key: string) => void;
}

const Locations: React.FC<Props> = ({ formProps, clearFilterKey }) => {
  let isVisible = false;

  if ((formProps?.values?.influencerLocation || []).length > 0) {
    isVisible = true;
  }

  return (
    <Field
      label="Influencer Location:"
      mb={20}
      color="black"
      isBeside={true}
      extra={
        isVisible && (
          <RemoveIcon
            type="close-circle"
            onClick={() => {
              formProps?.setFieldValue("influencerLocation", []);
              clearFilterKey("influencerLocation");
            }}
            style={{ marginTop: "-1px", marginLeft: "10px" }}
          />
        )
      }
      id="influencerLocation"
    >
      <FormikSelect
        name="influencerLocation"
        data={locations}
        local
        borderRadius={3}
        borderColor="grey5"
        size="middle"
        mode="multiple"
      />
    </Field>
  );
};

export default Locations;
